import { render, staticRenderFns } from "./shengqing_tixian.vue?vue&type=template&id=7bf161c2&scoped=true"
import script from "./shengqing_tixian.vue?vue&type=script&lang=js"
export * from "./shengqing_tixian.vue?vue&type=script&lang=js"
import style0 from "./shengqing_tixian.vue?vue&type=style&index=0&id=7bf161c2&prod&lang=scss&scoped=true"
import style1 from "./shengqing_tixian.vue?vue&type=style&index=1&id=7bf161c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf161c2",
  null
  
)

export default component.exports